import React, { useCallback, useContext, useRef, useState } from 'react';
import './styles.css';
import P from 'prop-types';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../contexts/HomeContext';
import { ExcluirEndereco, GetEnderecos } from '../../utils/api/api';
import { Button } from '../Button';
import { Capitalize } from '../../utils/utils';
import { EnderecoNovo } from '../EnderecoNovo';
import { Modal } from '../Modal';

export const Enderecos = ({ param }) => {
  const { user, enderecos, setEnderecos } = useContext(GlobalContext);
  const [isCadastro, setIsCadastro] = useState(false);
  const [loading, setLoading] = useState('none');
  const [enderecoSelecionado, setEnderecoSelecionado] = useState({});
  const itemEls = useRef({});

  let filter = (item) => item.titulo.toUpperCase() !== 'FATURA';
  if (param.isFatura) filter = (item) => item.titulo.toUpperCase() === 'FATURA';

  const showHideLoading = () => setLoading(loading == 'block' ? 'none' : 'block');

  const handelGetEnderecos = useCallback(() => {
    GetEnderecos(user.id).then((response) => {
      if (response.data.Retorno) {
        if (response.data.Retorno.status == 1) {
          toast.error('Erro ao carregar endereços! ' + response.data.Retorno.msg, { containerId: 'modalToast' });
          return;
        }
      }

      setEnderecos([...response.data]);
      setLoading('none');
    });
  }, [user.id, setEnderecos]);

  const handleShowOptions = (element) => {
    element.style.display = 'block';
  };

  const handleNewBackAddress = (value = false, reload = false) => {
    setEnderecoSelecionado({});
    setIsCadastro(value);
    if (reload) handelGetEnderecos();
  };

  const handleEditAddress = (endereco) => {
    setEnderecoSelecionado(endereco);
    setIsCadastro(true);
  };
  const handleDeleteAddress = async (id) => {
    if (id > 0) {
      showHideLoading();
      const response = await ExcluirEndereco(id);
      if (response.status == 200) {
        if (response.data.status == 0) {
          handelGetEnderecos();
          toast.success('Endereço excluído com sucesso', { containerId: 'modalToast' });
          return;
        }
      }
    }
    toast.error('Erro ao excluir o endereço', { containerId: 'modalToast' });
    setLoading(false);
  };

  const handleClick = (endereco) => {
    if (!param.isFinalizacao) return;

    param.setEnderecoEntrega(endereco);
    setTimeout(() => {
      param.closeModal();
    }, 150);
  };

  return (
    <>
      {!isCadastro && (
        <div className="modal-content-dialog" style={{ marginBottom: 20 }}>
          <Button
            className="btnWhite btn-shadow"
            text="Adicionar Novo Endereço"
            icon="add"
            iconAlign="right"
            onClick={() => handleNewBackAddress(true)}
          />
          {/* onClick={() => handleModal('NOVO_ENDERECO', 'Endereços')} */}
          {param.isFinalizacao && enderecos?.filter(filter).length > 0 && (
            <h4 style={{ fontSize: '1.25rem', textAlign: 'center', marginBottom: '20px' }}>Escolha o endereço</h4>
          )}
          {enderecos?.filter(filter).length <= 0 && (
            <h4 style={{ fontSize: '1.25rem', textAlign: 'center', marginBottom: '20px' }}>
              {param.isFatura ? 'Nenhum endereço de \nfatura cadastrado' : 'Nenhum endereço de entrega cadastrado'}
            </h4>
          )}
          {enderecos?.length > 0 && (
            <div className="cardShadow">
              {enderecos?.filter(filter).map((endereco, index) => (
                <div
                  className="btnWhite btn-shadow"
                  key={endereco.id}
                  onClick={() => handleClick(endereco)}
                  style={{ display: 'inline-table', padding: '10px 15px', marginBottom: '10px' }}
                >
                  {!param.isFinalizacao && (
                    <>
                      <div ref={(el) => (itemEls.current[index] = el)} style={{ display: 'none', float: 'left' }}>
                        <span
                          style={{ margin: '0 10px 0 0', color: '#e54750', cursor: 'pointer', float: 'left' }}
                          onClick={() => handleDeleteAddress(endereco.id)}
                        >
                          <i className="material-icons">clear</i>
                        </span>
                        <span
                          style={{ margin: '0 10px 0 0', color: '#e54750', cursor: 'pointer', float: 'left' }}
                          onClick={() => handleEditAddress(endereco)}
                        >
                          <i className="material-icons">create</i>
                          {/* onClick={() => handleModal('NOVO_ENDERECO', 'Endereços', endereco)} */}
                        </span>
                      </div>
                      <span
                        style={{ margin: '0 -10px 0 5px', color: '#e54750', cursor: 'pointer', float: 'right' }}
                        onClick={() => handleShowOptions(itemEls.current[index])}
                      >
                        <i className="material-icons">more_vert</i>
                      </span>
                    </>
                  )}

                  <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#000000', marginBottom: '20px' }}>
                    {' '}
                    {Capitalize(endereco.titulo)}
                  </p>
                  <p style={{ fontSize: '14px', margin: '0', color: '#000000' }}>
                    {endereco.endereco_complemento != ''
                      ? endereco.endereco + ', ' + endereco.endereco_numero + ', ' + endereco.endereco_complemento
                      : endereco.endereco + ', ' + endereco.endereco_numero}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {isCadastro && (
        <EnderecoNovo
          param={{
            isFatura: param.isFatura,
            endereco: { ...enderecoSelecionado },
            handleNewBackAddress: handleNewBackAddress,
            showHideLoading: showHideLoading,
            setLoading: setLoading,
          }}
        />
      )}
      {loading === 'block' && (
        <Modal
          title=""
          isFooter={false}
          visibility={loading}
          page="LOADING"
          param={{
            msg: 'Aguarde...',
          }}
          customPosition="loading-modal"
        />
      )}
    </>
  );
};

Enderecos.propTypes = {
  //handleModal: P.func,
  param: P.object,
};
